module.exports = __webpack_public_path__ + "img/success.f3f87684.png";